import { alpha } from '@mui/material';
const useFullHeightCardStyles = (variant, height) => {
    return {
        cardContentContainer: {
            height: height || 'calc(100dvh - 220px)',
            overflow: 'auto',
            '.assignTo-menu-btn': {
                color: (theme) => theme.palette.success.dark
            },
            '.task-status-chip': {
                backgroundColor: (theme) => alpha(theme.palette.success.main, 0.16),
                color: (theme) => variant === 'blue' ? theme.palette.success.light : theme.palette.success.dark
            }
        }
    };
};
export default useFullHeightCardStyles;
